import { shallowMount, createLocalVue } from "@vue/test-utils";
import Vuex from "vuex";
import TopBar from "@/components/core/TopBar";
import { watch } from "vue";

const localVue = createLocalVue();
localVue.use(Vuex);

describe("TopBar component", () => {
  let wrapper;
  let state;
  let config;
  let getters;

  beforeEach(() => {
    state = {
      route: {
        name: "mensajeErrorSolicitudCuenta"
      }
    };
    getters = {
      getRoute: function () {
        return () => ({
          route: {}
        });
      }
    };
    config = {
      pasos: {
        mensajeErrorSolicitudCuenta: {
          path: "/mensajeSolicitudCuenta/:mje",
          component: "views/MensajeErrorSolicitudCuenta",
          header: "Solicitud de Cuenta",
          titulo: "Esta oferta no está disponible",
          texto:
            "Ingresá a Banca Online y conocé los productos a los que podés acceder."
        }
      }
    };

    wrapper = shallowMount(TopBar, {
      localVue,
      mocks: {
        $store: {
          getters,
          state,
          watch
        },
        config
      }
    });
  });

  it("Renders del component TopBar", () => {
    expect(wrapper).toBeDefined();
  });
});
